module.exports = __webpack_public_path__ + "files/c8ca69eda709307189e686bfb4e76d8d.png";